module.exports = __webpack_public_path__ + "img/noticias-cel.aa5fdf03.png";